// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customer-feedback-section {
  margin-bottom: 16px;
  padding: 0;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  display: block;
}
.customer-feedback-section * {
  box-sizing: border-box;
}
.customer-feedback-section .feedback-header {
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
@media (min-width: 768px) {
  .customer-feedback-section .feedback-header {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
}
@media (max-width: 1024px) {
  .customer-feedback-section .feedback-header {
    background: #f9f9f9;
    border-radius: 12px;
    box-shadow: none;
  }
}
.customer-feedback-section .feedback-header .feedback-header-left {
  flex: 1;
}
.customer-feedback-section .feedback-header .feedback-header-left .feedback-title {
  font-size: 16px;
  font-weight: 500;
  line-height: 1.2;
  margin: 0 0 4px 0;
  color: #0f0f0f;
  display: flex;
  align-items: center;
  gap: 12px;
}
.customer-feedback-section .feedback-header .feedback-header-left .feedback-subtitle {
  font-size: 14px;
  color: #606060;
  margin: 0;
  line-height: 20px;
}
.customer-feedback-section .feedback-header .feedback-header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-shrink: 0;
}
.customer-feedback-section .feedback-header .feedback-header-actions .feedback-btn-secondary {
  padding: 12px 24px;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  font-weight: 600;
  font-size: 14px;
  color: #0f172a;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}
.customer-feedback-section .feedback-header .feedback-header-actions .feedback-btn-secondary:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
}
.customer-feedback-section .feedback-header .feedback-header-actions .btn-primary,
.customer-feedback-section .feedback-header .feedback-header-actions .btn-secondary {
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
  font-family: "Raleway";
}
.customer-feedback-section .feedback-header .feedback-header-actions .btn-primary:disabled,
.customer-feedback-section .feedback-header .feedback-header-actions .btn-secondary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.customer-feedback-section .feedback-header .feedback-header-actions .btn-primary {
  background: #5ea1d8;
  color: white;
}
.customer-feedback-section .feedback-header .feedback-header-actions .btn-primary:hover:not(:disabled) {
  background: #4a8fc4;
}
.customer-feedback-section .feedback-header .feedback-header-actions .btn-secondary {
  background: #f3f4f6;
  color: #374151;
}
.customer-feedback-section .feedback-header .feedback-header-actions .btn-secondary:hover:not(:disabled) {
  background: #e5e7eb;
}
.customer-feedback-section .feedback-summary-grid {
  display: grid !important;
  grid-template-columns: 1fr !important;
  gap: 16px !important;
  margin-bottom: 16px !important;
  width: 100% !important;
  max-width: 100% !important;
  box-sizing: border-box !important;
  visibility: visible !important;
  opacity: 1 !important;
}
@media (min-width: 1024px) {
  .customer-feedback-section .feedback-summary-grid {
    grid-template-columns: 1fr 2fr !important;
    display: grid !important;
  }
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card {
  padding: 16px !important;
  background: #ffffff !important;
  border-radius: 16px !important;
  margin-bottom: 16px !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  width: 100% !important;
  box-sizing: border-box !important;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header .rating-number {
  font-size: 32px;
  font-weight: 800;
  color: #0f172a;
  line-height: 1;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header .rating-stars-group .rating-stars {
  display: flex;
  gap: 2px;
  margin-bottom: 4px;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header .rating-stars-group .rating-stars .star-wrapper {
  position: relative;
  display: inline-block;
  width: 20px;
  height: 20px;
  line-height: 0;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header .rating-stars-group .rating-stars .star-wrapper .rating-star-icon {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #cbd5e1;
  line-height: 1;
  display: block;
  position: relative;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header .rating-stars-group .rating-stars .star-wrapper .rating-star-icon.filled-star {
  color: #f59e0b;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header .rating-stars-group .rating-stars .star-wrapper .rating-star-icon.partial-star {
  color: #f59e0b;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header .rating-stars-group .rating-stars .star-wrapper .rating-star-icon.star-empty-overlay {
  position: absolute;
  top: 0;
  left: 0;
  color: #cbd5e1;
  z-index: 1;
  pointer-events: none;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-display-header .rating-stars-group .rating-count-text {
  font-size: 13px;
  font-weight: 500;
  color: #64748b;
  margin: 0;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list .rating-bar-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 8px;
  transition: all 0.2s ease;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list .rating-bar-item:hover {
  background: #f8fafc;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list .rating-bar-item.selected {
  background: #eff6ff;
  border: 1px solid #5ea1d8;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list .rating-bar-item.selected .rating-label {
  color: #5ea1d8;
  font-weight: 700;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list .rating-bar-item.selected .rating-bar-progress {
  background: #5ea1d8;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list .rating-bar-item.selected .rating-percent {
  color: #5ea1d8;
  font-weight: 700;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list .rating-bar-item .rating-label {
  width: 42px;
  color: #475569;
  flex-shrink: 0;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list .rating-bar-item .rating-bar-bg {
  flex: 1;
  height: 8px;
  background: #f1f5f9;
  border-radius: 9999px;
  overflow: hidden;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list .rating-bar-item .rating-bar-bg .rating-bar-progress {
  height: 100%;
  background: #5ea1d8;
  border-radius: 9999px;
  transition: width 0.3s ease;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .rating-distribution-list .rating-bar-item .rating-percent {
  width: 28px;
  text-align: right;
  color: #64748b;
  flex-shrink: 0;
  font-size: 12px;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .ratings-info-btn {
  width: 100%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0;
  background: none;
  border: none;
  color: #5ea1d8;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .ratings-info-btn:hover {
  text-decoration: underline;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .ratings-info-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .filter-indicator {
  margin-top: 16px;
  padding: 12px;
  background: #eff6ff;
  border: 1px solid #5ea1d8;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .filter-indicator span {
  font-size: 13px;
  font-weight: 600;
  color: #5ea1d8;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .filter-indicator .clear-filter-btn {
  padding: 4px 12px;
  background: #5ea1d8;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.customer-feedback-section .feedback-summary-grid .rating-summary-card .filter-indicator .clear-filter-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card {
  position: relative !important;
  height: 100% !important;
  background: #ffffff !important;
  padding: 16px !important;
  border-radius: 16px !important;
  margin-bottom: 16px !important;
  overflow: hidden !important;
  display: block !important;
  visibility: visible !important;
  opacity: 1 !important;
  width: 100% !important;
  box-sizing: border-box !important;
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content {
  position: relative;
  z-index: 10;
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-highlights-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-highlights-header .ai-icon-wrapper {
  padding: 6px;
  background: #5ea1d8;
  color: #fff;
  border-radius: 6px;
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-highlights-header .ai-icon-wrapper .ai-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-highlights-header .ai-highlights-title {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin: 0;
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-summary-text {
  color: #0f0f0f;
  font-size: 14px;
  line-height: 20px;
  margin: 0 0 20px 0;
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 12px;
}
@media (min-width: 768px) {
  .customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid {
    grid-template-columns: 1fr 1fr;
  }
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
  margin: 0 0 8px 0;
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-list .ai-tag {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid;
  cursor: pointer;
  transition: all 0.2s;
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-list .ai-tag .tag-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  margin-right: 4px;
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-list .ai-tag.positive {
  background: #d1fae5;
  color: #065f46;
  border-color: #a7f3d0;
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-list .ai-tag.positive .tag-icon {
  color: #059669;
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-list .ai-tag.negative {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fecaca;
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-list .ai-tag.negative .tag-icon {
  color: #dc2626;
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-highlights-content .ai-tags-grid .ai-tags-column .ai-tags-list .ai-tag:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.customer-feedback-section .feedback-summary-grid .ai-highlights-card .ai-gradient-bg {
  position: absolute;
  top: -96px;
  right: -96px;
  width: 256px;
  height: 256px;
  background: rgba(79, 70, 229, 0.1);
  border-radius: 50%;
  filter: blur(100px);
  z-index: 1;
}
.customer-feedback-section .reviews-images-section {
  margin-bottom: 16px;
}
.customer-feedback-section .reviews-images-section .reviews-images-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.customer-feedback-section .reviews-images-section .reviews-images-header .reviews-images-title {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin: 0;
}
.customer-feedback-section .reviews-images-section .reviews-images-header .see-all-photos-link {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #5ea1d8;
  font-weight: 700;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;
}
.customer-feedback-section .reviews-images-section .reviews-images-header .see-all-photos-link:hover {
  text-decoration: underline;
}
.customer-feedback-section .reviews-images-section .reviews-images-header .see-all-photos-link mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.customer-feedback-section .reviews-images-section .masonry-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(2, 100px);
  gap: 16px;
}
.customer-feedback-section .reviews-images-section .masonry-grid .masonry-item {
  position: relative;
  overflow: hidden;
  border-radius: 20px;
  cursor: pointer;
  transition: transform 0.5s;
}
.customer-feedback-section .reviews-images-section .masonry-grid .masonry-item:hover {
  transform: scale(1.05);
}
.customer-feedback-section .reviews-images-section .masonry-grid .masonry-item:hover .masonry-overlay {
  opacity: 1;
}
.customer-feedback-section .reviews-images-section .masonry-grid .masonry-item.masonry-item-large {
  grid-column: span 2;
  grid-row: span 2;
}
.customer-feedback-section .reviews-images-section .masonry-grid .masonry-item .masonry-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.customer-feedback-section .reviews-images-section .masonry-grid .masonry-item .masonry-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.2);
  opacity: 0;
  transition: opacity 0.3s;
}
.customer-feedback-section .reviews-images-section .masonry-grid .masonry-item.masonry-item-more .masonry-more-overlay {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}
.customer-feedback-section .reviews-images-section .masonry-grid .masonry-item.masonry-item-more .masonry-more-overlay .masonry-more-text {
  color: #fff;
  font-size: 18px;
  font-weight: 700;
}
.customer-feedback-section .view-reviews-button-container {
  text-align: center;
  margin: 16px 0;
}
.customer-feedback-section .view-reviews-button-container .view-reviews-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 24px;
  background: #5ea1d8;
  border: none;
  border-radius: 10px;
  font-weight: 700;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 4px 6px rgba(94, 161, 216, 0.2);
}
.customer-feedback-section .view-reviews-button-container .view-reviews-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 6px 8px rgba(94, 161, 216, 0.3);
}
.customer-feedback-section .view-reviews-button-container .view-reviews-btn mat-icon {
  font-size: 18px;
  width: 18px;
  height: 18px;
}
.customer-feedback-section .top-reviews-section {
  padding: 0 16px;
}
@media (max-width: 768px) {
  .customer-feedback-section .top-reviews-section {
    padding: 0 12px;
  }
}
.customer-feedback-section .top-reviews-section .top-reviews-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}
.customer-feedback-section .top-reviews-section .top-reviews-header .top-reviews-title {
  font-size: 16px;
  font-weight: 500;
  color: #0f0f0f;
  margin: 0;
}
.customer-feedback-section .top-reviews-section .top-reviews-header .top-reviews-sort {
  display: flex;
  align-items: center;
  gap: 8px;
}
.customer-feedback-section .top-reviews-section .top-reviews-header .top-reviews-sort .sort-label {
  font-size: 14px;
  font-weight: 600;
  color: #64748b;
}
.customer-feedback-section .top-reviews-section .top-reviews-header .top-reviews-sort .sort-select {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  cursor: pointer;
}
.customer-feedback-section .top-reviews-section .top-reviews-header .top-reviews-sort .sort-select:focus {
  outline: none;
  border-color: #5ea1d8;
  box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);
}
.customer-feedback-section .top-reviews-section .top-reviews-list {
  display: flex;
  flex-direction: row;
  gap: 16px;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 8px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.customer-feedback-section .top-reviews-section .top-reviews-list::-webkit-scrollbar {
  height: 8px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list::-webkit-scrollbar-track {
  background: transparent;
}
.customer-feedback-section .top-reviews-section .top-reviews-list::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 4px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list::-webkit-scrollbar-thumb:hover {
  background-color: #94a3b8;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card {
  flex: 0 0 400px;
  min-width: 350px;
  max-width: 400px;
  padding: 16px;
  background: #ffffff;
  border-radius: 16px;
  margin-bottom: 0;
  transition: all 0.2s;
}
@media (max-width: 768px) {
  .customer-feedback-section .top-reviews-section .top-reviews-list .review-card {
    flex: 0 0 320px;
    min-width: 280px;
    max-width: 320px;
  }
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 8px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .review-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .review-meta .review-date {
  font-size: 12px;
  color: #6b7280;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .review-meta .review-status {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  background-color: #dcfce7;
  color: #16a34a;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .review-meta .review-issue-status {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  border-radius: 9999px;
  font-size: 11px;
  font-weight: 600;
  background-color: #ffedd5;
  color: #ea580c;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group {
  display: flex;
  align-items: center;
  gap: 10px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-avatar-circle {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  color: #4f46e5;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-name {
  font-weight: 700;
  font-size: 14px;
  color: #0f172a;
  margin: 0 0 2px 0;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group {
  display: flex;
  align-items: center;
  gap: 6px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group .review-rating-number {
  font-size: 14px;
  font-weight: 600;
  color: #0f172a;
  line-height: 1;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group .review-stars {
  display: flex;
  align-items: center;
  gap: 1px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group .review-stars.editable {
  gap: 2px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group .review-stars .review-star-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  color: #cbd5e1;
  line-height: 1;
  transition: all 0.2s ease;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group .review-stars .review-star-icon.filled-star {
  color: #f59e0b;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group .review-stars .review-star-icon.editable-star {
  cursor: pointer;
  transition: transform 0.15s ease, color 0.15s ease;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group .review-stars .review-star-icon.editable-star:hover {
  transform: scale(1.2);
  color: #f59e0b;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group .review-stars .review-star-icon.editable-star.filled-star:hover {
  color: #d97706;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group .edit-rating-icon {
  font-size: 14px;
  width: 14px;
  height: 14px;
  color: #64748b;
  cursor: pointer;
  margin-left: 4px;
  transition: all 0.2s ease;
  opacity: 0.7;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group .edit-rating-icon:hover {
  color: #0f172a;
  opacity: 1;
  transform: scale(1.1);
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .reviewer-info-group .reviewer-details .reviewer-rating-group .verified-badge {
  font-size: 10px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-header .review-date {
  font-size: 12px;
  color: #94a3b8;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-title {
  font-size: 14px;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 6px 0;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-text {
  color: #0f0f0f;
  line-height: 20px;
  font-size: 14px;
  margin: 0 0 12px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-media {
  margin: 12px 0;
  border-radius: 6px;
  overflow: hidden;
  max-width: 200px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-media .review-media-image,
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-media .review-media-video {
  max-width: 100%;
  max-height: 150px;
  object-fit: contain;
  border-radius: 6px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section {
  margin-top: 12px;
  padding: 10px;
  background: #eff6ff;
  border-left: 3px solid #5ea1d8;
  border-radius: 6px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issues-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issues-header .issues-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #5ea1d8;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issues-header strong {
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issue-item {
  margin-bottom: 12px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issue-item:last-child {
  margin-bottom: 0;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issue-item .issue-header {
  margin-bottom: 6px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issue-item .issue-header strong {
  font-size: 12px;
  font-weight: 700;
  color: #0f172a;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issue-item .issue-description {
  font-size: 14px;
  color: #0f0f0f;
  line-height: 20px;
  margin: 0 0 6px 0;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issue-item .issue-media {
  margin: 8px 0;
  border-radius: 6px;
  overflow: hidden;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issue-item .issue-media img,
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-issues-section .issue-item .issue-media video {
  max-width: 100%;
  max-height: 150px;
  object-fit: contain;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .creator-response-box {
  margin-top: 12px;
  padding: 10px;
  background: #eff6ff;
  border-left: 3px solid #3b82f6;
  border-radius: 6px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .creator-response-box .response-header {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .creator-response-box .response-header .response-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
  color: #3b82f6;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .creator-response-box .response-header strong {
  font-size: 12px;
  font-weight: 700;
  color: #1e40af;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .creator-response-box .response-text {
  font-size: 14px;
  color: #1e40af;
  line-height: 20px;
  margin: 0 0 4px 0;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .creator-response-box .response-date {
  font-size: 11px;
  color: #64748b;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .response-input-section {
  margin-top: 12px;
  padding: 12px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .response-input-section .full-width {
  width: 100%;
  margin-bottom: 12px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .response-input-section .response-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .response-input-section .response-actions .submit-btn {
  background-color: #5ea1d8;
  color: white;
  font-weight: 600;
  padding: 8px 24px;
  border-radius: 6px;
  text-transform: none;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .response-input-section .response-actions .submit-btn:hover {
  background-color: #4a8bc2;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions .helpful-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  font-weight: 700;
  font-size: 12px;
  color: #0f172a;
  cursor: pointer;
  transition: all 0.2s;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions .helpful-btn:hover:not(:disabled) {
  background: #f8fafc;
  border-color: #cbd5e1;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions .helpful-btn:disabled, .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions .helpful-btn.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background: #f1f5f9;
  color: #64748b;
  border-color: #e2e8f0;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions .helpful-btn mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions .report-btn {
  font-size: 12px;
  font-weight: 700;
  color: #94a3b8;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  transition: color 0.2s;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions .report-btn:hover:not(:disabled) {
  color: #475569;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions .report-btn.reported {
  color: #334155;
  opacity: 1;
}
.customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions .report-btn:disabled, .customer-feedback-section .top-reviews-section .top-reviews-list .review-card .review-card-actions .report-btn.disabled {
  opacity: 0.7;
  cursor: not-allowed;
  color: #64748b;
}
.customer-feedback-section .top-reviews-section .load-more-section {
  text-align: center;
  padding-top: 16px;
}
.customer-feedback-section .top-reviews-section .load-more-section .load-more-btn {
  padding: 16px 32px;
  background: #0f172a;
  color: #fff;
  border: none;
  border-radius: 12px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.customer-feedback-section .top-reviews-section .load-more-section .load-more-btn:hover {
  opacity: 0.9;
  transform: translateY(-1px);
}
.customer-feedback-section .top-reviews-section .load-more-section .no-reviews-message {
  color: #64748b;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
}

/* Dark mode overrides for View Flow review/feedback section */
:host-context(body.theme-dark) .customer-feedback-section .feedback-header,
:host-context(body.theme-dark) .customer-feedback-section .rating-summary-card,
:host-context(body.theme-dark) .customer-feedback-section .ai-highlights-card,
:host-context(body.theme-dark) .customer-feedback-section .review-card {
  background: #111827 !important;
  color: #ffffff !important;
  border: 1px solid rgba(148, 163, 184, 0.25) !important;
}
:host-context(body.theme-dark) .customer-feedback-section .feedback-title,
:host-context(body.theme-dark) .customer-feedback-section .feedback-subtitle,
:host-context(body.theme-dark) .customer-feedback-section .reviews-images-title,
:host-context(body.theme-dark) .customer-feedback-section .top-reviews-title,
:host-context(body.theme-dark) .customer-feedback-section .review-card-title,
:host-context(body.theme-dark) .customer-feedback-section .review-card-text,
:host-context(body.theme-dark) .customer-feedback-section .reviewer-name,
:host-context(body.theme-dark) .customer-feedback-section .review-date,
:host-context(body.theme-dark) .customer-feedback-section .rating-number,
:host-context(body.theme-dark) .customer-feedback-section .rating-count-text,
:host-context(body.theme-dark) .customer-feedback-section .ai-highlights-title,
:host-context(body.theme-dark) .customer-feedback-section .ai-summary-text,
:host-context(body.theme-dark) .customer-feedback-section .no-reviews-message,
:host-context(body.theme-dark) .customer-feedback-section .sort-label,
:host-context(body.theme-dark) .customer-feedback-section .review-rating-number {
  color: #ffffff !important;
}
:host-context(body.theme-dark) .customer-feedback-section .feedback-btn-secondary,
:host-context(body.theme-dark) .customer-feedback-section .sort-select,
:host-context(body.theme-dark) .customer-feedback-section .helpful-btn {
  background: #1f2937 !important;
  color: #ffffff !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .customer-feedback-section .feedback-btn-secondary:hover,
:host-context(body.theme-dark) .customer-feedback-section .helpful-btn:hover:not(:disabled),
:host-context(body.theme-dark) .customer-feedback-section .sort-select:focus {
  background: #374151 !important;
  border-color: #5ea1d8 !important;
}
:host-context(body.theme-dark) .customer-feedback-section .rating-bar-item:hover {
  background: rgba(148, 163, 184, 0.12) !important;
}
:host-context(body.theme-dark) .customer-feedback-section .rating-label,
:host-context(body.theme-dark) .customer-feedback-section .rating-percent,
:host-context(body.theme-dark) .customer-feedback-section .ai-tags-label,
:host-context(body.theme-dark) .customer-feedback-section .report-btn {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .customer-feedback-section .rating-bar-bg {
  background: #334155 !important;
}
:host-context(body.theme-dark) .customer-feedback-section .review-issues-section,
:host-context(body.theme-dark) .customer-feedback-section .creator-response-box,
:host-context(body.theme-dark) .customer-feedback-section .response-input-section {
  background: #0f172a !important;
  border-color: rgba(94, 161, 216, 0.35) !important;
}
:host-context(body.theme-dark) .customer-feedback-section .issue-description,
:host-context(body.theme-dark) .customer-feedback-section .response-text,
:host-context(body.theme-dark) .customer-feedback-section .issue-header strong,
:host-context(body.theme-dark) .customer-feedback-section .issues-header strong {
  color: #e2e8f0 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/customer-feedback-section/customer-feedback-section.component.scss"],"names":[],"mappings":"AACA;EACE,mBAAA;EACA,UAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,cAAA;AAAF;AAGE;EACE,sBAAA;AADJ;AAKE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EAEA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAJJ;AAMI;EAVF;IAWI,mBAAA;IACA,uBAAA;IACA,8BAAA;EAHJ;AACF;AAKI;EAhBF;IAiBI,mBAAA;IACA,mBAAA;IACA,gBAAA;EAFJ;AACF;AAII;EACE,OAAA;AAFN;AAIM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAFR;AAKM;EACE,eAAA;EACA,cAAA;EACA,SAAA;EACA,iBAAA;AAHR;AAOI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AALN;AAOM;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;EACA,yCAAA;AALR;AAOQ;EACE,mBAAA;EACA,qBAAA;AALV;AASM;;EAEE,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,sBAAA;AAPR;AASQ;;EACE,YAAA;EACA,mBAAA;AANV;AAUM;EACE,mBAAA;EACA,YAAA;AARR;AAUQ;EACE,mBAAA;AARV;AAYM;EACE,mBAAA;EACA,cAAA;AAVR;AAYQ;EACE,mBAAA;AAVV;AAiBE;EACE,wBAAA;EACA,qCAAA;EACA,oBAAA;EACA,8BAAA;EACA,sBAAA;EACA,0BAAA;EACA,iCAAA;EACA,8BAAA;EACA,qBAAA;AAfJ;AAiBI;EAXF;IAYI,yCAAA;IACA,wBAAA;EAdJ;AACF;AAiBI;EACE,wBAAA;EACA,8BAAA;EACA,8BAAA;EAEA,8BAAA;EACA,yBAAA;EACA,8BAAA;EACA,qBAAA;EACA,sBAAA;EACA,iCAAA;AAhBN;AAkBM;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAhBR;AAkBQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAhBV;AAoBU;EACE,aAAA;EACA,QAAA;EACA,kBAAA;AAlBZ;AAoBY;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAlBd;AAoBc;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,cAAA;EACA,kBAAA;AAlBhB;AAoBgB;EACE,cAAA;AAlBlB;AAqBgB;EACE,cAAA;AAnBlB;AAsBgB;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,cAAA;EACA,UAAA;EACA,oBAAA;AApBlB;AA0BU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAxBZ;AA6BM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA3BR;AA6BQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AA3BV;AA6BU;EACE,mBAAA;AA3BZ;AA8BU;EACE,mBAAA;EACA,yBAAA;AA5BZ;AA8BY;EACE,cAAA;EACA,gBAAA;AA5Bd;AA+BY;EACE,mBAAA;AA7Bd;AAgCY;EACE,cAAA;EACA,gBAAA;AA9Bd;AAkCU;EACE,WAAA;EACA,cAAA;EACA,cAAA;AAhCZ;AAmCU;EACE,OAAA;EACA,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;AAjCZ;AAmCY;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;AAjCd;AAqCU;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AAnCZ;AAwCM;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AAtCR;AAwCQ;EACE,0BAAA;AAtCV;AAyCQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAvCV;AA2CM;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAzCR;AA2CQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAzCV;AA4CQ;EACE,iBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AA1CV;AA4CU;EACE,YAAA;EACA,2BAAA;AA1CZ;AAiDE;EACE,6BAAA;EACA,uBAAA;EACA,8BAAA;EACA,wBAAA;EACA,8BAAA;EAEA,8BAAA;EACA,2BAAA;EACA,yBAAA;EACA,8BAAA;EACA,qBAAA;EACA,sBAAA;EACA,iCAAA;AAhDJ;AAkDM;EACE,kBAAA;EACA,WAAA;AAhDR;AAkDQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AAhDV;AAkDU;EACE,YAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;AAhDZ;AAkDY;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAhDd;AAoDU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AAlDZ;AAsDQ;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AApDV;AAuDQ;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AArDV;AAuDU;EALF;IAMI,8BAAA;EApDV;AACF;AAuDY;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cAAA;EACA,iBAAA;AArDd;AAwDY;EACE,aAAA;EACA,eAAA;EACA,QAAA;AAtDd;AAwDc;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,oBAAA;AAtDhB;AAwDgB;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AAtDlB;AAyDgB;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAvDlB;AAyDkB;EACE,cAAA;AAvDpB;AA2DgB;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AAzDlB;AA2DkB;EACE,cAAA;AAzDpB;AA6DgB;EACE,2BAAA;EACA,wCAAA;AA3DlB;AAmEM;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,kCAAA;EACA,kBAAA;EACA,mBAAA;EACA,UAAA;AAjER;AAuEE;EACE,mBAAA;AArEJ;AAuEM;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AArEN;AAuEM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AArER;AAwEM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,eAAA;EACA,oBAAA;AAtER;AAwEQ;EACE,0BAAA;AAtEV;AAyEQ;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAvEV;AA4EI;EACE,aAAA;EACA,qCAAA;EACA,oCAAA;EACA,SAAA;AA1EN;AA4EM;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,0BAAA;AA1ER;AA4EQ;EACE,sBAAA;AA1EV;AA4EU;EACE,UAAA;AA1EZ;AA8EQ;EACE,mBAAA;EACA,gBAAA;AA5EV;AA+EQ;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AA7EV;AAgFQ;EACE,kBAAA;EACA,QAAA;EACA,8BAAA;EACA,UAAA;EACA,wBAAA;AA9EV;AAkFU;EACE,kBAAA;EACA,QAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAhFZ;AAkFY;EACE,WAAA;EACA,eAAA;EACA,gBAAA;AAhFd;AAyFE;EACE,kBAAA;EACA,cAAA;AAvFJ;AAyFI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,oBAAA;EACA,6CAAA;AAvFN;AAyFM;EACE,YAAA;EACA,2BAAA;EACA,6CAAA;AAvFR;AA0FM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AAxFR;AA8FE;EACE,eAAA;AA5FJ;AA8FI;EAHF;IAII,eAAA;EA3FJ;AACF;AA6FI;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AA3FN;AA6FM;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;AA3FR;AA8FM;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AA5FR;AA8FQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA5FV;AA+FQ;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;AA7FV;AA+FU;EACE,aAAA;EACA,qBAAA;EACA,6CAAA;AA7FZ;AAmGI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oCAAA;AAjGN;AAmGM;EACE,WAAA;AAjGR;AAoGM;EACE,uBAAA;AAlGR;AAqGM;EACE,yBAAA;EACA,kBAAA;AAnGR;AAqGQ;EACE,yBAAA;AAnGV;AAuGM;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EAEA,gBAAA;EACA,oBAAA;AAtGR;AAwGQ;EAXF;IAYI,eAAA;IACA,gBAAA;IACA,gBAAA;EArGR;AACF;AA2GQ;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,kBAAA;AAzGV;AA2GU;EACE,aAAA;EACA,sBAAA;EACA,qBAAA;EACA,QAAA;AAzGZ;AA2GY;EACE,eAAA;EACA,cAAA;AAzGd;AA4GY;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AA1Gd;AA6GY;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;AA3Gd;AA+GU;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AA7GZ;AA+GY;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AA7Gd;AAiHc;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AA/GhB;AAkHc;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAhHhB;AAkHgB;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;AAhHlB;AAmHgB;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AAjHlB;AAmHkB;EACE,QAAA;AAjHpB;AAoHkB;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,cAAA;EACA,yBAAA;AAlHpB;AAoHoB;EACE,cAAA;AAlHtB;AAqHoB;EACE,eAAA;EACA,kDAAA;AAnHtB;AAqHsB;EACE,qBAAA;EACA,cAAA;AAnHxB;AAuHwB;EACE,cAAA;AArH1B;AA4HgB;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;AA1HlB;AA4HkB;EACE,cAAA;EACA,UAAA;EACA,qBAAA;AA1HpB;AA8HgB;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,sBAAA;AA5HlB;AAkIU;EACE,eAAA;EACA,cAAA;AAhIZ;AAoIQ;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAlIV;AAqIQ;EACE,cAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;AAnIV;AAsIQ;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AApIV;AAsIU;;EAEE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AApIZ;AAwIQ;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAtIV;AAwIU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAtIZ;AAwIY;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAtId;AAyIY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAvId;AA2IU;EACE,mBAAA;AAzIZ;AA2IY;EACE,gBAAA;AAzId;AA4IY;EACE,kBAAA;AA1Id;AA4Ic;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AA1IhB;AA8IY;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AA5Id;AA+IY;EACE,aAAA;EACA,kBAAA;EACA,gBAAA;AA7Id;AA+Ic;;EAEE,eAAA;EACA,iBAAA;EACA,mBAAA;AA7IhB;AAmJQ;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAjJV;AAmJU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AAjJZ;AAmJY;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAjJd;AAoJY;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAlJd;AAsJU;EACE,eAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;AApJZ;AAuJU;EACE,eAAA;EACA,cAAA;AArJZ;AAyJQ;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;AAvJV;AAyJU;EACE,WAAA;EACA,mBAAA;AAvJZ;AA0JU;EACE,aAAA;EACA,yBAAA;EACA,QAAA;AAxJZ;AA0JY;EACE,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,oBAAA;AAxJd;AA0Jc;EACE,yBAAA;AAxJhB;AA8JQ;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;AA5JV;AA8JU;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,oBAAA;AA5JZ;AA8JY;EACE,mBAAA;EACA,qBAAA;AA5Jd;AA+JY;EAEE,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;AA9Jd;AAiKY;EACE,eAAA;EACA,WAAA;EACA,YAAA;AA/Jd;AAmKU;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,sBAAA;AAjKZ;AAmKY;EACE,cAAA;AAjKd;AAoKY;EACE,cAAA;EACA,UAAA;AAlKd;AAqKY;EAEE,YAAA;EACA,mBAAA;EACA,cAAA;AApKd;AA2KI;EACE,kBAAA;EACA,iBAAA;AAzKN;AA2KM;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AAzKR;AA2KQ;EACE,YAAA;EACA,2BAAA;AAzKV;AA6KM;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;AA3KR;;AAiLA,8DAAA;AAGI;;;;EAIE,8BAAA;EACA,yBAAA;EACA,sDAAA;AAhLN;AAmLI;;;;;;;;;;;;;;;EAeE,yBAAA;AAjLN;AAoLI;;;EAGE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAlLN;AAqLI;;;EAGE,8BAAA;EACA,gCAAA;AAnLN;AAsLI;EACE,gDAAA;AApLN;AAuLI;;;;EAIE,yBAAA;AArLN;AAwLI;EACE,8BAAA;AAtLN;AAyLI;;;EAGE,8BAAA;EACA,iDAAA;AAvLN;AA0LI;;;;EAIE,yBAAA;AAxLN","sourcesContent":["// Modern Customer Feedback Section (Reference Style)\n.customer-feedback-section {\n  margin-bottom: 16px;\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n  box-sizing: border-box;\n  display: block;\n  \n  // Force all child elements to inherit display\n  * {\n    box-sizing: border-box;\n  }\n\n  // Header Section\n  .feedback-header {\n    padding: 16px;\n    background: #ffffff;\n    border-radius: 16px;\n    //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n    margin-bottom: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n\n    @media (min-width: 768px) {\n      flex-direction: row;\n      align-items: flex-start;\n      justify-content: space-between;\n    }\n\n    @media (max-width: 1024px) {\n      background: #f9f9f9;\n      border-radius: 12px;\n      box-shadow: none;\n    }\n\n    .feedback-header-left {\n      flex: 1;\n\n      .feedback-title {\n        font-size: 16px;\n        font-weight: 500;\n        line-height: 1.2;\n        margin: 0 0 4px 0;\n        color: #0f0f0f;\n        display: flex;\n        align-items: center;\n        gap: 12px;\n      }\n\n      .feedback-subtitle {\n        font-size: 14px;\n        color: #606060;\n        margin: 0;\n        line-height: 20px;\n      }\n    }\n\n    .feedback-header-actions {\n      display: flex;\n      align-items: center;\n      gap: 16px;\n      flex-shrink: 0;\n\n      .feedback-btn-secondary {\n        padding: 12px 24px;\n        background: #fff;\n        border: 1px solid #e2e8f0;\n        border-radius: 12px;\n        font-weight: 600;\n        font-size: 14px;\n        color: #0f172a;\n        cursor: pointer;\n        transition: all 0.2s;\n        box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n\n        &:hover {\n          background: #f8fafc;\n          border-color: #cbd5e1;\n        }\n      }\n\n      .btn-primary,\n      .btn-secondary {\n        padding: 12px 24px;\n        border-radius: 8px;\n        font-size: 14px;\n        font-weight: 500;\n        cursor: pointer;\n        transition: all 0.2s ease;\n        border: none;\n        font-family: \"Raleway\";\n\n        &:disabled {\n          opacity: 0.5;\n          cursor: not-allowed;\n        }\n      }\n\n      .btn-primary {\n        background: #5ea1d8;\n        color: white;\n\n        &:hover:not(:disabled) {\n          background: #4a8fc4;\n        }\n      }\n\n      .btn-secondary {\n        background: #f3f4f6;\n        color: #374151;\n\n        &:hover:not(:disabled) {\n          background: #e5e7eb;\n        }\n      }\n    }\n  }\n\n  // Summary Grid (Two Columns)\n  .feedback-summary-grid {\n    display: grid !important;\n    grid-template-columns: 1fr !important;\n    gap: 16px !important;\n    margin-bottom: 16px !important;\n    width: 100% !important;\n    max-width: 100% !important;\n    box-sizing: border-box !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n\n    @media (min-width: 1024px) {\n      grid-template-columns: 1fr 2fr !important;\n      display: grid !important;\n    }\n\n    // Left: Rating Summary Card\n    .rating-summary-card {\n      padding: 16px !important;\n      background: #ffffff !important;\n      border-radius: 16px !important;\n      //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n      margin-bottom: 16px !important;\n      display: block !important;\n      visibility: visible !important;\n      opacity: 1 !important;\n      width: 100% !important;\n      box-sizing: border-box !important;\n\n      .rating-display-header {\n        display: flex;\n        align-items: flex-start;\n        gap: 12px;\n        margin-bottom: 16px;\n\n        .rating-number {\n          font-size: 32px;\n          font-weight: 800;\n          color: #0f172a;\n          line-height: 1;\n        }\n\n        .rating-stars-group {\n          .rating-stars {\n            display: flex;\n            gap: 2px;\n            margin-bottom: 4px;\n\n            .star-wrapper {\n              position: relative;\n              display: inline-block;\n              width: 20px;\n              height: 20px;\n              line-height: 0;\n\n              .rating-star-icon {\n                font-size: 20px;\n                width: 20px;\n                height: 20px;\n                color: #cbd5e1;\n                line-height: 1;\n                display: block;\n                position: relative;\n\n                &.filled-star {\n                  color: #f59e0b;\n                }\n\n                &.partial-star {\n                  color: #f59e0b;\n                }\n\n                &.star-empty-overlay {\n                  position: absolute;\n                  top: 0;\n                  left: 0;\n                  color: #cbd5e1;\n                  z-index: 1;\n                  pointer-events: none;\n                }\n              }\n            }\n          }\n\n          .rating-count-text {\n            font-size: 13px;\n            font-weight: 500;\n            color: #64748b;\n            margin: 0;\n          }\n        }\n      }\n\n      .rating-distribution-list {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n\n        .rating-bar-item {\n          display: flex;\n          align-items: center;\n          gap: 10px;\n          font-size: 12px;\n          font-weight: 500;\n          padding: 4px 8px;\n          border-radius: 8px;\n          transition: all 0.2s ease;\n\n          &:hover {\n            background: #f8fafc;\n          }\n\n          &.selected {\n            background: #eff6ff;\n            border: 1px solid #5ea1d8;\n            \n            .rating-label {\n              color: #5ea1d8;\n              font-weight: 700;\n            }\n            \n            .rating-bar-progress {\n              background: #5ea1d8;\n            }\n            \n            .rating-percent {\n              color: #5ea1d8;\n              font-weight: 700;\n            }\n          }\n\n          .rating-label {\n            width: 42px;\n            color: #475569;\n            flex-shrink: 0;\n          }\n\n          .rating-bar-bg {\n            flex: 1;\n            height: 8px;\n            background: #f1f5f9;\n            border-radius: 9999px;\n            overflow: hidden;\n\n            .rating-bar-progress {\n              height: 100%;\n              background: #5ea1d8;\n              border-radius: 9999px;\n              transition: width 0.3s ease;\n            }\n          }\n\n          .rating-percent {\n            width: 28px;\n            text-align: right;\n            color: #64748b;\n            flex-shrink: 0;\n            font-size: 12px;\n          }\n        }\n      }\n\n      .ratings-info-btn {\n        width: 100%;\n        margin-top: 20px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        gap: 6px;\n        padding: 0;\n        background: none;\n        border: none;\n        color: #5ea1d8;\n        font-weight: 700;\n        font-size: 13px;\n        cursor: pointer;\n        transition: all 0.2s;\n\n        &:hover {\n          text-decoration: underline;\n        }\n\n        mat-icon {\n          font-size: 16px;\n          width: 16px;\n          height: 16px;\n        }\n      }\n\n      .filter-indicator {\n        margin-top: 16px;\n        padding: 12px;\n        background: #eff6ff;\n        border: 1px solid #5ea1d8;\n        border-radius: 8px;\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        gap: 12px;\n\n        span {\n          font-size: 13px;\n          font-weight: 600;\n          color: #5ea1d8;\n        }\n\n        .clear-filter-btn {\n          padding: 4px 12px;\n          background: #5ea1d8;\n          color: #fff;\n          border: none;\n          border-radius: 6px;\n          font-size: 12px;\n          font-weight: 600;\n          cursor: pointer;\n          transition: all 0.2s;\n\n          &:hover {\n            opacity: 0.9;\n            transform: translateY(-1px);\n          }\n        }\n      }\n    }\n\n  // Right: AI Highlights Card\n  .ai-highlights-card {\n    position: relative !important;\n    height: 100% !important;\n    background: #ffffff !important;\n    padding: 16px !important;\n    border-radius: 16px !important;\n    //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n    margin-bottom: 16px !important;\n    overflow: hidden !important;\n    display: block !important;\n    visibility: visible !important;\n    opacity: 1 !important;\n    width: 100% !important;\n    box-sizing: border-box !important;\n\n      .ai-highlights-content {\n        position: relative;\n        z-index: 10;\n\n        .ai-highlights-header {\n          display: flex;\n          align-items: center;\n          gap: 8px;\n          margin-bottom: 16px;\n\n          .ai-icon-wrapper {\n            padding: 6px;\n            background: #5ea1d8;\n            color: #fff;\n            border-radius: 6px;\n\n            .ai-icon {\n              font-size: 18px;\n              width: 18px;\n              height: 18px;\n            }\n          }\n\n          .ai-highlights-title {\n            font-size: 16px;\n            font-weight: 500;\n            color: #0f0f0f;\n            margin: 0;\n          }\n        }\n\n        .ai-summary-text {\n          color: #0f0f0f;\n          font-size: 14px;\n          line-height: 20px;\n          margin: 0 0 20px 0;\n        }\n\n        .ai-tags-grid {\n          display: grid;\n          grid-template-columns: 1fr;\n          gap: 12px;\n\n          @media (min-width: 768px) {\n            grid-template-columns: 1fr 1fr;\n          }\n\n          .ai-tags-column {\n            .ai-tags-label {\n              font-size: 11px;\n              font-weight: 700;\n              text-transform: uppercase;\n              letter-spacing: 0.05em;\n              color: #94a3b8;\n              margin: 0 0 8px 0;\n            }\n\n            .ai-tags-list {\n              display: flex;\n              flex-wrap: wrap;\n              gap: 6px;\n\n              .ai-tag {\n                display: inline-flex;\n                align-items: center;\n                padding: 4px 10px;\n                border-radius: 9999px;\n                font-size: 12px;\n                font-weight: 600;\n                border: 1px solid;\n                cursor: pointer;\n                transition: all 0.2s;\n\n                .tag-icon {\n                  font-size: 14px;\n                  width: 14px;\n                  height: 14px;\n                  margin-right: 4px;\n                }\n\n                &.positive {\n                  background: #d1fae5;\n                  color: #065f46;\n                  border-color: #a7f3d0;\n\n                  .tag-icon {\n                    color: #059669;\n                  }\n                }\n\n                &.negative {\n                  background: #fee2e2;\n                  color: #991b1b;\n                  border-color: #fecaca;\n\n                  .tag-icon {\n                    color: #dc2626;\n                  }\n                }\n\n                &:hover {\n                  transform: translateY(-1px);\n                  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n                }\n              }\n            }\n          }\n        }\n      }\n\n      .ai-gradient-bg {\n        position: absolute;\n        top: -96px;\n        right: -96px;\n        width: 256px;\n        height: 256px;\n        background: rgba(79, 70, 229, 0.1);\n        border-radius: 50%;\n        filter: blur(100px);\n        z-index: 1;\n      }\n    }\n  }\n\n  // Reviews with Images Section\n  .reviews-images-section {\n    margin-bottom: 16px;\n\n      .reviews-images-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-bottom: 16px;\n\n      .reviews-images-title {\n        font-size: 16px;\n        font-weight: 500;\n        color: #0f0f0f;\n        margin: 0;\n      }\n\n      .see-all-photos-link {\n        display: flex;\n        align-items: center;\n        gap: 4px;\n        color: #5ea1d8;\n        font-weight: 700;\n        font-size: 14px;\n        text-decoration: none;\n        cursor: pointer;\n        transition: all 0.2s;\n\n        &:hover {\n          text-decoration: underline;\n        }\n\n        mat-icon {\n          font-size: 18px;\n          width: 18px;\n          height: 18px;\n        }\n      }\n    }\n\n    .masonry-grid {\n      display: grid;\n      grid-template-columns: repeat(4, 1fr);\n      grid-template-rows: repeat(2, 100px);\n      gap: 16px;\n\n      .masonry-item {\n        position: relative;\n        overflow: hidden;\n        border-radius: 20px;\n        cursor: pointer;\n        transition: transform 0.5s;\n\n        &:hover {\n          transform: scale(1.05);\n\n          .masonry-overlay {\n            opacity: 1;\n          }\n        }\n\n        &.masonry-item-large {\n          grid-column: span 2;\n          grid-row: span 2;\n        }\n\n        .masonry-image {\n          width: 100%;\n          height: 100%;\n          object-fit: cover;\n        }\n\n        .masonry-overlay {\n          position: absolute;\n          inset: 0;\n          background: rgba(0, 0, 0, 0.2);\n          opacity: 0;\n          transition: opacity 0.3s;\n        }\n\n        &.masonry-item-more {\n          .masonry-more-overlay {\n            position: absolute;\n            inset: 0;\n            background: rgba(15, 23, 42, 0.6);\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            z-index: 10;\n\n            .masonry-more-text {\n              color: #fff;\n              font-size: 18px;\n              font-weight: 700;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // View Reviews Button\n  .view-reviews-button-container {\n    text-align: center;\n    margin: 16px 0;\n    \n    .view-reviews-btn {\n      display: inline-flex;\n      align-items: center;\n      gap: 6px;\n      padding: 10px 24px;\n      background: #5ea1d8;\n      border: none;\n      border-radius: 10px;\n      font-weight: 700;\n      font-size: 14px;\n      color: #fff;\n      cursor: pointer;\n      transition: all 0.2s;\n      box-shadow: 0 4px 6px rgba(94, 161, 216, 0.2);\n\n      &:hover {\n        opacity: 0.9;\n        transform: translateY(-1px);\n        box-shadow: 0 6px 8px rgba(94, 161, 216, 0.3);\n      }\n\n      mat-icon {\n        font-size: 18px;\n        width: 18px;\n        height: 18px;\n      }\n    }\n  }\n\n  // Top Reviews Section\n  .top-reviews-section {\n    padding: 0 16px;\n\n    @media (max-width: 768px) {\n      padding: 0 12px;\n    }\n\n    .top-reviews-header {\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      margin-bottom: 16px;\n\n      .top-reviews-title {\n        font-size: 16px;\n        font-weight: 500;\n        color: #0f0f0f;\n        margin: 0;\n      }\n\n      .top-reviews-sort {\n        display: flex;\n        align-items: center;\n        gap: 8px;\n\n        .sort-label {\n          font-size: 14px;\n          font-weight: 600;\n          color: #64748b;\n        }\n\n        .sort-select {\n          background: #fff;\n          border: 1px solid #e2e8f0;\n          border-radius: 8px;\n          padding: 8px 12px;\n          font-size: 14px;\n          font-weight: 600;\n          color: #0f172a;\n          cursor: pointer;\n\n          &:focus {\n            outline: none;\n            border-color: #5ea1d8;\n            box-shadow: 0 0 0 3px rgba(94, 161, 216, 0.1);\n          }\n        }\n      }\n    }\n\n    .top-reviews-list {\n      display: flex;\n      flex-direction: row;\n      gap: 16px;\n      overflow-x: auto;\n      overflow-y: hidden;\n      padding-bottom: 8px;\n      scrollbar-width: thin;\n      scrollbar-color: #cbd5e1 transparent;\n\n      &::-webkit-scrollbar {\n        height: 8px;\n      }\n\n      &::-webkit-scrollbar-track {\n        background: transparent;\n      }\n\n      &::-webkit-scrollbar-thumb {\n        background-color: #cbd5e1;\n        border-radius: 4px;\n        \n        &:hover {\n          background-color: #94a3b8;\n        }\n      }\n\n      .review-card {\n        flex: 0 0 400px;\n        min-width: 350px;\n        max-width: 400px;\n        padding: 16px;\n        background: #ffffff;\n        border-radius: 16px;\n        //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n        margin-bottom: 0;\n        transition: all 0.2s;\n\n        @media (max-width: 768px) {\n          flex: 0 0 320px;\n          min-width: 280px;\n          max-width: 320px;\n        }\n\n        &:hover {\n          //box-shadow: 0 12px 28px rgba(31, 47, 70, 0.1);\n        }\n\n        .review-card-header {\n          display: flex;\n          align-items: flex-start;\n          justify-content: space-between;\n          margin-bottom: 8px;\n\n          .review-meta {\n            display: flex;\n            flex-direction: column;\n            align-items: flex-end;\n            gap: 2px;\n\n            .review-date {\n              font-size: 12px;\n              color: #6b7280;\n            }\n\n            .review-status {\n              display: inline-flex;\n              align-items: center;\n              padding: 4px 10px;\n              border-radius: 9999px;\n              font-size: 11px;\n              font-weight: 600;\n              background-color: #dcfce7;\n              color: #16a34a;\n            }\n\n            .review-issue-status {\n              display: inline-flex;\n              align-items: center;\n              padding: 4px 10px;\n              border-radius: 9999px;\n              font-size: 11px;\n              font-weight: 600;\n              background-color: #ffedd5;\n              color: #ea580c;\n            }\n          }\n\n          .reviewer-info-group {\n            display: flex;\n            align-items: center;\n            gap: 10px;\n\n            .reviewer-avatar-circle {\n              width: 36px;\n              height: 36px;\n              border-radius: 50%;\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              font-weight: 700;\n              font-size: 14px;\n              color: #4f46e5;\n            }\n\n            .reviewer-details {\n              .reviewer-name {\n                font-weight: 700;\n                font-size: 14px;\n                color: #0f172a;\n                margin: 0 0 2px 0;\n              }\n\n              .reviewer-rating-group {\n                display: flex;\n                align-items: center;\n                gap: 6px;\n\n                .review-rating-number {\n                  font-size: 14px;\n                  font-weight: 600;\n                  color: #0f172a;\n                  line-height: 1;\n                }\n\n                .review-stars {\n                  display: flex;\n                  align-items: center;\n                  gap: 1px;\n\n                  &.editable {\n                    gap: 2px;\n                  }\n\n                  .review-star-icon {\n                    font-size: 14px;\n                    width: 14px;\n                    height: 14px;\n                    color: #cbd5e1;\n                    line-height: 1;\n                    transition: all 0.2s ease;\n\n                    &.filled-star {\n                      color: #f59e0b;\n                    }\n\n                    &.editable-star {\n                      cursor: pointer;\n                      transition: transform 0.15s ease, color 0.15s ease;\n\n                      &:hover {\n                        transform: scale(1.2);\n                        color: #f59e0b;\n                      }\n\n                      &.filled-star {\n                        &:hover {\n                          color: #d97706;\n                        }\n                      }\n                    }\n                  }\n                }\n\n                .edit-rating-icon {\n                  font-size: 14px;\n                  width: 14px;\n                  height: 14px;\n                  color: #64748b;\n                  cursor: pointer;\n                  margin-left: 4px;\n                  transition: all 0.2s ease;\n                  opacity: 0.7;\n\n                  &:hover {\n                    color: #0f172a;\n                    opacity: 1;\n                    transform: scale(1.1);\n                  }\n                }\n\n                .verified-badge {\n                  font-size: 10px;\n                  font-weight: 700;\n                  color: #94a3b8;\n                  text-transform: uppercase;\n                  letter-spacing: 0.05em;\n                }\n              }\n            }\n          }\n\n          .review-date {\n            font-size: 12px;\n            color: #94a3b8;\n          }\n        }\n\n        .review-card-title {\n          font-size: 14px;\n          font-weight: 700;\n          color: #0f172a;\n          margin: 0 0 6px 0;\n        }\n\n        .review-card-text {\n          color: #0f0f0f;\n          line-height: 20px;\n          font-size: 14px;\n          margin: 0 0 12px 0;\n          display: -webkit-box;\n          -webkit-line-clamp: 2;\n          -webkit-box-orient: vertical;\n          overflow: hidden;\n        }\n\n        .review-card-media {\n          margin: 12px 0;\n          border-radius: 6px;\n          overflow: hidden;\n          max-width: 200px;\n\n          .review-media-image,\n          .review-media-video {\n            max-width: 100%;\n            max-height: 150px;\n            object-fit: contain;\n            border-radius: 6px;\n          }\n        }\n\n        .review-issues-section {\n          margin-top: 12px;\n          padding: 10px;\n          background: #eff6ff;\n          border-left: 3px solid #5ea1d8;\n          border-radius: 6px;\n\n          .issues-header {\n            display: flex;\n            align-items: center;\n            gap: 6px;\n            margin-bottom: 8px;\n\n            .issues-icon {\n              font-size: 16px;\n              width: 16px;\n              height: 16px;\n              color: #5ea1d8;\n            }\n\n            strong {\n              font-size: 12px;\n              font-weight: 700;\n              color: #0f172a;\n            }\n          }\n\n          .issue-item {\n            margin-bottom: 12px;\n\n            &:last-child {\n              margin-bottom: 0;\n            }\n\n            .issue-header {\n              margin-bottom: 6px;\n\n              strong {\n                font-size: 12px;\n                font-weight: 700;\n                color: #0f172a;\n              }\n            }\n\n            .issue-description {\n              font-size: 14px;\n              color: #0f0f0f;\n              line-height: 20px;\n              margin: 0 0 6px 0;\n            }\n\n            .issue-media {\n              margin: 8px 0;\n              border-radius: 6px;\n              overflow: hidden;\n\n              img,\n              video {\n                max-width: 100%;\n                max-height: 150px;\n                object-fit: contain;\n              }\n            }\n          }\n        }\n\n        .creator-response-box {\n          margin-top: 12px;\n          padding: 10px;\n          background: #eff6ff;\n          border-left: 3px solid #3b82f6;\n          border-radius: 6px;\n\n          .response-header {\n            display: flex;\n            align-items: center;\n            gap: 6px;\n            margin-bottom: 6px;\n\n            .response-icon {\n              font-size: 16px;\n              width: 16px;\n              height: 16px;\n              color: #3b82f6;\n            }\n\n            strong {\n              font-size: 12px;\n              font-weight: 700;\n              color: #1e40af;\n            }\n          }\n\n          .response-text {\n            font-size: 14px;\n            color: #1e40af;\n            line-height: 20px;\n            margin: 0 0 4px 0;\n          }\n\n          .response-date {\n            font-size: 11px;\n            color: #64748b;\n          }\n        }\n\n        .response-input-section {\n          margin-top: 12px;\n          padding: 12px;\n          background: #f8fafc;\n          border: 1px solid #e2e8f0;\n          border-radius: 8px;\n\n          .full-width {\n            width: 100%;\n            margin-bottom: 12px;\n          }\n\n          .response-actions {\n            display: flex;\n            justify-content: flex-end;\n            gap: 8px;\n\n            .submit-btn {\n              background-color: #5ea1d8;\n              color: white;\n              font-weight: 600;\n              padding: 8px 24px;\n              border-radius: 6px;\n              text-transform: none;\n\n              &:hover {\n                background-color: #4a8bc2;\n              }\n            }\n          }\n        }\n\n        .review-card-actions {\n          display: flex;\n          align-items: center;\n          gap: 12px;\n          margin-top: 12px;\n\n          .helpful-btn {\n            display: flex;\n            align-items: center;\n            gap: 6px;\n            padding: 6px 12px;\n            border: 1px solid #e2e8f0;\n            border-radius: 6px;\n            background: #fff;\n            font-weight: 700;\n            font-size: 12px;\n            color: #0f172a;\n            cursor: pointer;\n            transition: all 0.2s;\n\n            &:hover:not(:disabled) {\n              background: #f8fafc;\n              border-color: #cbd5e1;\n            }\n\n            &:disabled,\n            &.disabled {\n              opacity: 0.6;\n              cursor: not-allowed;\n              background: #f1f5f9;\n              color: #64748b;\n              border-color: #e2e8f0;\n            }\n\n            mat-icon {\n              font-size: 16px;\n              width: 16px;\n              height: 16px;\n            }\n          }\n\n          .report-btn {\n            font-size: 12px;\n            font-weight: 700;\n            color: #94a3b8;\n            background: none;\n            border: none;\n            cursor: pointer;\n            padding: 0;\n            transition: color 0.2s;\n\n            &:hover:not(:disabled) {\n              color: #475569;\n            }\n\n            &.reported {\n              color: #334155; // a bit darker for the 'Reported' state\n              opacity: 1;\n            }\n\n            &:disabled,\n            &.disabled {\n              opacity: 0.7;\n              cursor: not-allowed;\n              color: #64748b;\n            }\n          }\n        }\n      }\n    }\n\n    .load-more-section {\n      text-align: center;\n      padding-top: 16px;\n\n      .load-more-btn {\n        padding: 16px 32px;\n        background: #0f172a;\n        color: #fff;\n        border: none;\n        border-radius: 12px;\n        font-weight: 700;\n        font-size: 14px;\n        cursor: pointer;\n        transition: all 0.2s;\n\n        &:hover {\n          opacity: 0.9;\n          transform: translateY(-1px);\n        }\n      }\n\n      .no-reviews-message {\n        color: #64748b;\n        font-size: 16px;\n        font-weight: 500;\n        margin: 0;\n      }\n    }\n  }\n}\n\n/* Dark mode overrides for View Flow review/feedback section */\n:host-context(body.theme-dark) {\n  .customer-feedback-section {\n    .feedback-header,\n    .rating-summary-card,\n    .ai-highlights-card,\n    .review-card {\n      background: #111827 !important;\n      color: #ffffff !important;\n      border: 1px solid rgba(148, 163, 184, 0.25) !important;\n    }\n\n    .feedback-title,\n    .feedback-subtitle,\n    .reviews-images-title,\n    .top-reviews-title,\n    .review-card-title,\n    .review-card-text,\n    .reviewer-name,\n    .review-date,\n    .rating-number,\n    .rating-count-text,\n    .ai-highlights-title,\n    .ai-summary-text,\n    .no-reviews-message,\n    .sort-label,\n    .review-rating-number {\n      color: #ffffff !important;\n    }\n\n    .feedback-btn-secondary,\n    .sort-select,\n    .helpful-btn {\n      background: #1f2937 !important;\n      color: #ffffff !important;\n      border-color: rgba(148, 163, 184, 0.3) !important;\n    }\n\n    .feedback-btn-secondary:hover,\n    .helpful-btn:hover:not(:disabled),\n    .sort-select:focus {\n      background: #374151 !important;\n      border-color: #5ea1d8 !important;\n    }\n\n    .rating-bar-item:hover {\n      background: rgba(148, 163, 184, 0.12) !important;\n    }\n\n    .rating-label,\n    .rating-percent,\n    .ai-tags-label,\n    .report-btn {\n      color: #cbd5e1 !important;\n    }\n\n    .rating-bar-bg {\n      background: #334155 !important;\n    }\n\n    .review-issues-section,\n    .creator-response-box,\n    .response-input-section {\n      background: #0f172a !important;\n      border-color: rgba(94, 161, 216, 0.35) !important;\n    }\n\n    .issue-description,\n    .response-text,\n    .issue-header strong,\n    .issues-header strong {\n      color: #e2e8f0 !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
